module.exports = __webpack_public_path__ + "img/1299.867ea738.gif";